module.exports = __webpack_public_path__ + "img/view_alerts_icon.beaec9b7.png";